import React, { useEffect, useState } from 'react'
import GetInternships from '../../actions/GetInternships'
import InternshipItem from './InternshipItem'
import Localbase from 'localbase'

import Paper from '@mui/material/Paper';
import InputBase from '@mui/material/InputBase';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import SearchIcon from '@mui/icons-material/Search';
import DirectionsIcon from '@mui/icons-material/Directions';
import SetPage from '../../data/SetPage'
import Checkbox from '@mui/material/Checkbox';
import { Alert, Skeleton } from '@mui/material';
import { Link } from 'react-router-dom';
import CourseSuggestions from '../community/CourseSuggestions';
import WorkshopsSuggestions from '../dashboard/WorkshopsSuggestions';
import DetectDevice from '../../data/DetectDevice';
import { Helmet } from 'react-helmet';
import GetCourses from "../../actions/GetCourses";

const InternshipsPage = () => {
  const [courses, setCourses] = useState([]);
  const [access, setaccess] = useState(false);
  const [loading, setLoading] = useState(true)
  useEffect(() => {
    window.scrollTo(0, 0);
    fetchCourses();
  }, []);

  const fetchCourses = async () => {
    try {
      const res = await GetCourses({
        payload: {
          mode: "live",
          limit: 50,
        },
      });
      setCourses(res || []);
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  };
  const [loading2, setloading] = useState(true)
  let db = new Localbase("db")
  const [internships, setinternships] = useState(null)
  const NewGetInternships = async () => {
    setloading(true)
    const res = await GetInternships()
    if (res.status === 'success') {
      setloading(false)
      setinternships(res.data)
      db.collection("paths").add({
        internships: res.data
      }, "internships")

    }
  }

  useEffect(() => {
    SetPage("Internships")
    db.collection("paths").doc("internships").get().then(data => {
      setinternships(data.internships)

    }).catch(error => {

    })
    NewGetInternships()
  }, [])
  const device = DetectDevice()
  return (
    <>


      <Helmet>‍
        <title>Internships & Job Opportunities | Careers - Skills Uprise</title>‍
        <meta name="description" content="Login into your account and learn the best skills from our curated courses" />
        <meta name="twitter:card" content="" />
        <meta name="twitter:site" content="@skillsuprise" />
        <meta name="twitter:creator" content="@skillsuprise" />
        <meta name="twitter:title" content="" />
        <meta name="twitter:description" content="" />
        <meta name="twitter:image" content="" />
        <meta property="og:title" content="" />
        <meta property="og:description" content="" />
        <meta property="og:image" content="" />
        <meta property="og:url" content="" />
        <meta property="og:site_name" content="Skills Uprise" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:type" content="article" />
        <meta property="fb:app_id" content="ID_APP_FACEBOOK" />
      </Helmet>

      <div className="container  pt-3 pb-5 d-flex flex-wrap justify-content-between mb-5">
        <div className="col-lg-7 col-md-12 col-sm-12 col-12 sm-mx-auto animation-active  mt-3">
          {/* <h4 className="fw-bold mb-1 pb-0">🚀 Latest Opportunities</h4>
          <p className="text-grey mb-4">
            Explore pre-placement internship roles from SiliconMinds
          </p> */}


          {internships ?
            <>
              {internships.map((internship, index) => (

                <>
                  <InternshipItem className={"w-100"} internship={internship} index={index} />
                </>
              ))}
            </> : <>


              <Skeleton variant="rectangle" height={100} className="w-100 mt-2 mb-2" />

              <Skeleton variant="rectangle" height={100} className="w-100 mt-2 mb-2" />

              <Skeleton variant="rectangle" height={100} className="w-100 mt-2 mb-2" />

              <Skeleton variant="rectangle" height={100} className="w-100 mt-2 mb-2" />

              <Skeleton variant="rectangle" height={100} className="w-100 mt-2 mb-2" />

              <Skeleton variant="rectangle" height={100} className="w-100 mt-2 mb-2" />

            </>}



        </div>












        <div className="col-lg-4 d-none d-sm-block h-fit p-3 ">

          {device === "mobile" ?
            <>

            </> : <>
              <div className="mt-0 mx-1 col-12">
                <div className="mb-3">
                  <h4 style={{ fontWeight: "700", marginBottom: "4px" }}>
                    ⭐ Popular Courses
                  </h4>
                  <p style={{ color: "#6c757d", marginBottom: "12px", fontSize: "0.9rem" }}>
                    Trending live programs to boost your career
                  </p>
                </div>

                {/* <CommunitySuggestions account={account} /> */}
                {/* <OnlineCourses/> */}

                {loading ? (
                  <p className="text-center">Loading courses...</p>
                ) : (
                  <div className="col-12">
                    {courses.slice(0, 6).map((course, index) => (
                      <Link
                        key={index}
                        to={
                          "/course/" +
                          course.course_url +
                          "/" +
                          course.mode
                        }
                        className="text-decoration-none d-block mb-3"
                      >
                        <div
                          className="ly-card-horizontal"
                          style={{
                            display: "flex",
                            background: "#fff",
                            borderRadius: "12px",
                            boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
                            overflow: "hidden",
                            transition: "all 0.3s ease",
                            cursor: "pointer",
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.boxShadow =
                              "0 8px 24px rgba(0,0,0,0.15)";
                            e.currentTarget.style.transform =
                              "translateY(-4px)";
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.boxShadow =
                              "0 4px 12px rgba(0,0,0,0.08)";
                            e.currentTarget.style.transform =
                              "translateY(0)";
                          }}
                        >
                          {/* IMAGE - LEFT SIDE */}
                          <div
                            style={{
                              width: "140px",
                              minWidth: "140px",
                              height: "130px",
                              overflow: "hidden",
                              background: "#f0f0f0",
                            }}
                          >
                            <img
                              src={course.course_cover_url}
                              alt={course.course_title}
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                                transition: "transform 0.3s ease",
                              }}
                              onMouseEnter={(e) => {
                                e.currentTarget.style.transform =
                                  "scale(1.1)";
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.transform =
                                  "scale(1)";
                              }}
                            />
                          </div>

                          {/* BODY - RIGHT SIDE */}
                          <div
                            className="p-3"
                            style={{
                              flex: 1,
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "space-between",
                              minWidth: 0,
                            }}
                          >
                            {/* Title */}
                            <h5
                              className="ly-title mb-2"
                              style={{
                                color: "#1a3a52",
                                fontWeight: 700,
                                fontSize: "0.95rem",
                                lineHeight: "1.3",
                                margin: 0,
                                display: "-webkit-box",
                                WebkitLineClamp: 2,
                                WebkitBoxOrient: "vertical",
                                overflow: "hidden",
                              }}
                            >
                              {course.course_title}
                            </h5>

                            {/* Rating */}
                            <div
                              className="d-flex align-items-center mb-2"
                              style={{
                                fontSize: "0.85rem",
                                gap: "4px",
                              }}
                            >
                              <span
                                style={{
                                  color: "#ffc107",
                                  letterSpacing: "1px",
                                }}
                              >
                                {Array.from(
                                  {
                                    length: Math.floor(course.rating),
                                  },
                                  (_) => "★",
                                ).join("")}
                                {course.rating % 1 >= 0.5 ? "½" : ""}
                              </span>
                              <span
                                style={{
                                  color: "#222",
                                  fontWeight: 600,
                                }}
                              >
                                {course.rating}
                              </span>
                              <span
                                style={{
                                  color: "#888",
                                  fontSize: "0.8rem",
                                }}
                              >
                                (
                                {course.ratings_count ||
                                  course.course_ratings ||
                                  0}
                                )
                              </span>
                            </div>

                            {/* Price */}
                            <div className="d-flex align-items-center justify-content-between gap-2">
                              <div className="d-flex align-items-center gap-2">
                                <span
                                  className="ly-price"
                                  style={{
                                    color: "#d32f2f",
                                    fontWeight: 700,
                                    fontSize: "1.1rem",
                                  }}
                                >
                                  {course.course_price}
                                </span>
                                <del
                                  style={{
                                    color: "#999",
                                    fontSize: "0.85rem",
                                    textDecoration: "line-through",
                                  }}
                                >
                                  {course.course_cutoff_price}
                                </del>
                              </div>
                              <i
                                className="bi bi-arrow-right"
                                style={{
                                  color: "#0056d6",
                                  fontWeight: 700,
                                  transition: "transform 0.3s ease",
                                }}
                                onMouseEnter={(e) => {
                                  e.currentTarget.style.transform =
                                    "translateX(4px)";
                                }}
                                onMouseLeave={(e) => {
                                  e.currentTarget.style.transform =
                                    "translateX(0)";
                                }}
                              ></i>
                            </div>
                          </div>
                        </div>
                      </Link>
                    ))}
                  </div>
                )}
              </div>

              {/* <WorkshopsSuggestions/> */}

            </>}


        </div>



      </div>


    </>
  )
}

export default InternshipsPage